import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { isSignedIn } from "@culturehq/client";
import { Loader } from "@culturehq/components";

import { useProfile } from "app/context";
import { canCreateEvent } from "app/permissions";
import { errorService } from "app/utils";

const isPermitted = (profile, requires) => {
  // User has been created and authenticated but not yet accepted the terms
  // and conditions. (Most likely because of SAML authentication.)
  if (!profile.claimed) {
    return false;
  }

  switch (requires) {
    case "chq":
      return profile.culturehqAdmin;
    case "superadmin":
      return profile.organizationAdmin;
    case "admin":
      return profile.organizationAdmin || profile.role === "content_admin";
    case "slack":
      return profile.organizationAdmin
        || profile.organization.userCreatedSlackIntegrationsEnabled;
    case "recognitions":
      return profile.organization.recognitionsEnabled;
    case "surveys":
      return profile.organization.surveysEnabled;
    case "createEvent":
      return canCreateEvent(profile);
    case "events":
      return profile.organization.eventsEnabled;
    case "posts":
      return profile.organization.postsEnabled;
    default:
      return isSignedIn();
  }
};

class PrivateRouteContext extends Component {
  getRedirect() {
    const { profile: { claimed } } = this.props;

    if (!isSignedIn()) {
      errorService.log("Redirect to login, private route");
      return "/login";
    }
    if (!claimed) {
      return "/accept/sso";
    }
    return "/403";
  }

  render() {
    const { component: Wrapped, requires, profile, ...rest } = this.props;

    // Wait for profile to load. Show a loading indicator until we know that we
    // have a profile in memory to check
    if (isSignedIn() && !profile.id) {
      return <Loader loading />;
    }

    return (
      <Route
        {...rest}
        render={props => (
          isPermitted(profile, requires)
            ? <Wrapped {...props} />
            : <Redirect to={{ pathname: this.getRedirect(), state: { from: props.location } }} />
        )}
      />
    );
  }
}

const PrivateRoute = props => {
  const { profile } = useProfile();

  return <PrivateRouteContext {...props} profile={profile} />;
};

export default PrivateRoute;
